import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { TableReducer } from "./Redux/TableSlice";
import RawData from "./ContentPage/RawData";
import NfcLog from "./ContentPage/NfcLog";
import VpiLog from "./ContentPage/VpiLog";

const HeaderTop = tw.div`flex flex-row items-center justify-center bg-white border-b-2 text-center py-2 `;
const HeaderTitle = tw.div`text-sm md:text-xl font-bold relative py-3 mx-4  md:mx-0 text-gray-500 cursor-pointer`


const Container = tw.div``
const Content = tw.div` p-4 md:p-14 bg-white`


const DetailsContainer = tw.div`w-full  `;
const Detail = tw.div`my-2`


const Heading = tw.h5`text-xl font-semibold  truncate  `;
const Subheading = tw.h5`text-base  truncate text-gray-500 `;


export default () => {

    const dispatch = useDispatch();

    const number = useSelector((state) => state.TableComponent.value);

    return (
        <Container>


            <HeaderTop>
                <HeaderTitle style={{ width: "15%",  color: number === "RawData" ?"black": null }}  onClick={() => dispatch(TableReducer(1)) }>RAW DATA</HeaderTitle>
                <HeaderTitle style={{ width: "15%",  color: number === "NfcLogs" ?"black": null }}  onClick={() => dispatch(TableReducer(2)) } >NFC LOGS</HeaderTitle>
                <HeaderTitle style={{ width: "15%",  color: number === "VpiLogs" ?"black": null }}  onClick={() => dispatch(TableReducer(3)) } >VPI LOGS</HeaderTitle>
                <HeaderTitle style={{ width: "55%" }}></HeaderTitle>
            </HeaderTop>


         

            
      {number === "default" ?    <Content>
                <DetailsContainer>
                    <Detail>
                        <Heading>Machine Name</Heading>
                    </Detail>
                    <Detail>
                        <Subheading>Location </Subheading>
                        <Heading>Area Name</Heading>
                    </Detail>
                    <Detail>
                        <Subheading>Machine Status </Subheading>
                        <Heading>25</Heading>
                    </Detail>
                    <Detail>
                        <Subheading>Network Status </Subheading>
                        <Heading>11:00 - 12:00</Heading>
                    </Detail>
                    <Detail>
                        <Subheading>Product Status </Subheading>
                        <Heading>25</Heading>
                    </Detail>
                </DetailsContainer>
            </Content> : null}

            
      {number === "RawData" ? <RawData/> : null}
      {number === "NfcLogs" ? <NfcLog/> : null}
      {number === "VpiLogs" ? <VpiLog/> : null}
      

        </Container>
    )

};